/* eslint-disable @typescript-eslint/no-explicit-any */
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";
import { toast } from "components/ui/use-toast";
import { useRef, useState } from "react";
import { MdOutlineFileUpload } from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import {
  useGetFilesQuery,
  usePublicGetFilesQuery,
  usePublicUploadFileMutation,
  useUploadFileMutation,
} from "@/services/file";
import { featureFlags } from "@/config/feature-flag";

interface FormData {
  evidence: FileList;
}

export default function EvidenceCell({ row, entity_name, methods }: any) {
  const uploadFileMutationPrivate = useUploadFileMutation();
  const uploadFileMutationPublic = usePublicUploadFileMutation();

  const featureFlagsChoice = featureFlags.USE_KEYCLOAK;

  const [uploadFile] = featureFlagsChoice
    ? uploadFileMutationPublic
    : uploadFileMutationPrivate;

  const fileInputRef = useRef<HTMLInputElement>(null);
  const { handleSubmit, setValue } = methods;
  const [isUploading, setIsUploading] = useState(false);

  const rowId = row?.original?.id;
  const objectGetFiles = {
    entity_name: entity_name ?? "",
    id: rowId?.toString() ?? "",
  };
  const getFileKeycloak = featureFlagsChoice
    ? usePublicGetFilesQuery(objectGetFiles)
    : useGetFilesQuery(objectGetFiles);

  const { data: response } = getFileKeycloak;

  const filesData = response?.data ?? [];
  const filesCount = filesData.length;

  setValue(`divergence_opr.length_file_${rowId}`, filesCount);

  const onSubmit = async (data: FormData) => {
    try {
      setIsUploading(true);
      if (data.evidence && data.evidence.length > 0) {
        const file = data.evidence[0];

        await uploadFile({
          file,
          entity_name,
          entity_id: row.original.id as number,
          audit: true,
        }).unwrap();

        toast({
          variant: "default",
          description: "Evidência enviada com sucesso",
          duration: 5000,
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }
    } catch (error) {
      console.error("Failed to upload file:", error);
      toast({
        variant: "destructive",
        description: "Erro ao realizar ação",
        duration: 5000,
      });
    } finally {
      setIsUploading(false);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const fileList = e.target.files;
      setValue("evidence", fileList);
      handleSubmit(() => onSubmit({ evidence: fileList }))();
    }
  };

  const triggerFileInput = () => {
    if (fileInputRef.current && !isUploading) {
      fileInputRef.current.click();
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger
        onClick={triggerFileInput}
        className={`w-full h-full px-[10px] py-[6px] flex items-center justify-center gap-4 ${
          isUploading ? "opacity-50 cursor-not-allowed" : ""
        }`}
      >
        <div className="w-full h-full px-[10px] py-[6px] flex items-center justify-center gap-4">
          {filesCount > 0 && (
            <span className="truncate overflow-hidden whitespace-nowrap underline cursor-pointer">
              {filesData
                .slice(0, 3)
                .map((file: any) => file?.file_name ?? "Arquivo")
                .join(", ")}{" "}
              <span className="text-[#74788D]">...</span>
            </span>
          )}
          <div>
            {isUploading ? (
              <AiOutlineLoading3Quarters className="text-black animate-spin !text-[16px] font-bold" />
            ) : (
              <MdOutlineFileUpload className="text-black cursor-pointer !text-[16px] font-bold" />
            )}
            <input
              type="file"
              onChange={handleFileChange}
              ref={fileInputRef}
              className="hidden"
              disabled={isUploading}
            />
          </div>
        </div>
      </TooltipTrigger>
      {filesCount > 0 && (
        <TooltipContent className="bg-black text-white text-center">
          <span>{filesData.map((file: any) => file?.file_name ?? "Arquivo").join(", ")}</span>
        </TooltipContent>
      )}
    </Tooltip>
  );
}
